import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { facilityStayAction } from 'src/redux/actions/constant';
import facilityStayService from 'src/services/apiServices/facilityStayService';

const {
  REQUEST_GET_ALL_FACILITIES,
  SUCCESS_GET_ALL_FACILITIES,
  FAILURE_GET_ALL_FACILITIES,
  CREATE_FACILITIES_LOADING,
} = facilityStayAction;

function* getAllFacilities(action: any): SagaReturnType<any> {
  try {
    yield put({ type: CREATE_FACILITIES_LOADING });
    const response = yield call(facilityStayService.getAllFacilities, action.payload);
    if (response?.status === 200) {
      yield put({ type: SUCCESS_GET_ALL_FACILITIES, payload: response });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: FAILURE_GET_ALL_FACILITIES, payload: error });
  }
}

function* getAllFacilitiesSaga() {
  yield takeEvery(REQUEST_GET_ALL_FACILITIES, getAllFacilities);
}

export default getAllFacilitiesSaga;
